import { render, staticRenderFns } from "./RankingsTable.vue?vue&type=template&id=1cda36bc&scoped=true"
import script from "./RankingsTable.vue?vue&type=script&lang=js"
export * from "./RankingsTable.vue?vue&type=script&lang=js"
import style0 from "./RankingsTable.vue?vue&type=style&index=0&id=1cda36bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda36bc",
  null
  
)

export default component.exports